export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-pricetag-multiple-bf497d5045d1de6153056c617664627c.svg";